(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["submenu_block"]) return;
  try {
    
  setTimeout($('.quicklink_nav.sevices_nav').removeClass('hidden'), 1000)
  $(document).ready(function(){
  if($(".active_state").length > 1){
      $(".active_state")[0].classList.remove("active_state")
    }

        var menu_slider = document.querySelector('.sevices_nav');
    var selected_nav = document.querySelector('.sevices_nav .fontlink_format .active_state');
      var isDown = false;
      var startX, scrollLeft, startMenuOffset;
    if(selected_nav !== null){
      startMenuOffset = Math.ceil(selected_nav.getBoundingClientRect().x) - 20;
    }
      menu_slider.scroll(startMenuOffset, 0)
      menu_slider.addEventListener('mousedown', (e) => {
        isDown = true;
        startX = e.pageX - menu_slider.offsetLeft;
        scrollLeft = menu_slider.scrollLeft;
      });
      
      menu_slider.addEventListener('mouseleave', () => { isDown = false });

      menu_slider.addEventListener('mouseup', () => { isDown = false });

      menu_slider.addEventListener('mousemove', (e) => {
        if(!isDown) return;
        e.preventDefault();
        const x = e.pageX - menu_slider.offsetLeft;
        const walk = (x - startX) * 1.5; //scroll-fast
        menu_slider.scrollLeft = scrollLeft - walk;
        
        if(e.currentTarget === document.querySelector('.disable_moblink')){
          if(e.currentTarget.scrollLeft > 0){ e.currentTarget.classList.add('fixedtitle')}
        } });
    
  })



    

  } catch(e) { console.error(e); }
})();

})();
